import { useState, ChangeEvent, useEffect } from "react";
import { InputAdornment, TextField, Button, IconButton } from "@mui/material";
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import { useCurrencyRates } from "@/src/services";
const param = {
    "url": "https://api.freecurrencyapi.com/v1/latest",
    "apikey": "rI2tOGCXUNNHtI2RSG4HrHhYhrsvK45LHe8RBj9N",
    "base_currency": "USD",
    "currencies": "USD,EUR,GBP"
};

const knownCurrencies = ["USD", "EUR", "GBP"];
param.currencies = knownCurrencies.join();


export const PriceCalculator = () => {

    const [calculatorIsOpen, setCalculatorIsOpen] = useState<boolean>(false);

    const handleOpenCalc = () => {
        setCalculatorIsOpen(oldValue => !oldValue)
    };

    return (
        <div>
            <IconButton onClick={handleOpenCalc}>
                <CalculateOutlinedIcon />
            </IconButton>
            {calculatorIsOpen && <PriceCalculatorInternal />}
        </div>
    )
}


const initCurrencyValues = Object.fromEntries(knownCurrencies.map(c => [c, ""]))
const PriceCalculatorInternal = (props: any) => {

    const [prices, setPrices] = useState<Record<string, string>>(initCurrencyValues);

    const { valueIn, isFetched } = useCurrencyRates()

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {

        if (isFetched) {
            const newPrices: Record<string, string> = {};
            knownCurrencies.forEach(currency => {
                const { name, value } = e.target;
                if (name !== currency) {
                    const val = valueIn(Number(value), currency, name);
                    newPrices[currency] = val ? val.toFixed(2) : "";////((rates[currency] * Number(value)) / rates[name]).toFixed(2);
                } else {
                    newPrices[currency] = value;
                }
            })

            setPrices(newPrices)
        }
    }
    console.log(prices)
    return (
        <div>
            {knownCurrencies.map((currency: any) => {
                console.log(prices[currency])
                return <TextField
                    name={currency}
                    key={currency}
                    value={prices[currency]}
                    onChange={handleChange}
                    variant={"outlined"}
                    label={'calculator'}
                    margin={'dense'}

                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                {currency}{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            }
            )}
        </div>
    );
};
